
        <ig-page-spinner [loadingTip]="'Redirecting to Google Map...'"></ig-page-spinner>
    


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/gps.redirect.component.ts.GpsRedirectComponent.html